import React from "react";

import Sidebar from "./Sidebar";
import Header from "./Header";
import i1 from "../../../img/undraw_profile.svg";
import post from "../../../assests/b1.jpg";
const MyPost = () => {
  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header d-flex align-items-center justify-content-between py-3 w-100">
                  <div className="d-flex align-items-center">
                    <img src={i1} className="profile-img" />
                    <h6 className="ms-2 mb-0 font-weight-bold text-primary">
                      Pet Parents
                    </h6>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button className="btn btn-primary me-3">
                      View Members
                    </button>
                    <button className="btn btn-primary">Add Post</button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="card com-post-card-new shadow mb-4">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <div className="profile-name-img">
                        <div className="d-flex align-items-center">
                          <img src={i1} className="profile-img" />
                          <h6 className="ms-2 mb-0 font-weight-bold text-primary">
                            Maxwell Gomes
                          </h6>
                        </div>
                      </div>
                      <div className="delet-icon">
                        <i class="fas fa-trash"></i>
                      </div>
                    </div>

                    <div className="card-body">
                      <div class="image-gallery">
                        <div class="image-item">
                          <img src={post} className="post-img" />
                        </div>
                        <div class="image-item">
                          <img src={post} className="post-img" />
                        </div>
                        <div class="image-item">
                          <img src={post} className="post-img" />
                        </div>
                        <div class="image-item more">
                          <img src={post} className="post-img" />
                          <div class="overlay">+1</div>
                        </div>
                      </div>
                      <div className="like-div"></div>
                    </div>
                  </div>

                  <div className="card com-post-card-new shadow mb-4">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <div className="profile-name-img">
                        <div className="d-flex align-items-center">
                          <img src={i1} className="profile-img" />
                          <h6 className="ms-2 mb-0 font-weight-bold text-primary">
                            Maxwell Gomes
                          </h6>
                        </div>
                      </div>
                      <div className="delet-icon">
                        <i class="fas fa-trash"></i>
                      </div>
                    </div>

                    <div className="card-body">
                      <div className="com-img-card">
                        <img src={post} className="post-img" />
                      </div>
                      <div className="like-div"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyPost;
